import Splide from '@splidejs/splide';

export default (el) => {
    const config = {
        type: 'slide',
        rewind: true,
        perPage: 1,
        gap: '3rem',
        autoplay: el.dataset.autoplay == 'false' ? false : 5000,
        keyboard: false,
        pagination: false,
        drag: true,
        mediaQuery: 'min',
        breakpoints: {
            851: {
                destroy: true,
            },
        }
    }

    let splide = new Splide('.splide.-content-cards', config).mount();

};
